import { SORTING_ORDERS } from "@/constants";
import { mapActions } from "vuex";

/**
 * Common utilities required by most of the components
 * @author {Jatin Kamboj}
 */
export default {
  name: "SharedUtilsMixin",
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    const { msg: errorMessage } = this.$dictionary.errors.common;
    const { snackbarTypes } = this.$appConfig.snackbar;
    return {
      snackbarTypes,
      errorMessage,
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    /**
     * Computes the sorting configuration of the listing to be shown in the table
     * @param {String} prop Name of the property defined in parent component which holds the properties of table sorting
     * @param {String} sortOrder Default sort order of the listing
     * @returns {Object}
     */
    getSortConfig(prop = "params", sortOrder) {
      const sortConfig = this[prop]["q[s]"]
        ? this[prop]["q[s]"]?.split(" ")
        : null;

      return {
        sortBy: sortConfig?.[0] ?? SORTING_ORDERS.asc,
        sortOrder: sortConfig?.[1] ?? sortOrder,
      };
    },
  },
};
